import { featureFlagManager } from 'core/config/feature-flags/featureFlagManager'
import { type EnvType } from 'core/infra/environment'

import { type featureFlag } from './constants.featureFlags'

const DEFAULT_OPTIONS = {
  flagManager: featureFlagManager,
}

const getEnv = (env?: EnvType) => (env ? { currentEnv: env } : env)

export function useFeatureFlag(
  flag: featureFlag,
  config?: { flagManager?: typeof featureFlagManager; currentEnv?: EnvType }
) {
  const { flagManager, currentEnv } = { ...DEFAULT_OPTIONS, ...config }
  const managerConfig = getEnv(currentEnv)

  return {
    isEnabled: flagManager.isEnabledForEnv(flag, managerConfig),
  }
}

export type UseFeatureFlagParams = Parameters<typeof useFeatureFlag>
